import { useMemo } from "react";
import { Flame } from "lucide-react";

export default function MomentumMeter({ score, peak }) {
  const level = useMemo(() => {
    if (score >= 100) return { name: "flow state", color: "#ff3d8b" };
    if (score >= 60) return { name: "locked in", color: "#4ade80" };
    if (score >= 30) return { name: "warming up", color: "#a7f3d0" };
    if (score >= 10) return { name: "building", color: "#facc15" };
    return { name: "starting", color: "hsl(0, 0%, 65%)" };
  }, [score]);

  return (
    <div className="card-elevated p-5" data-testid="momentum-meter">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.25em] text-white/40">
          <Flame className="w-3.5 h-3.5" style={{ color: level.color }} /> Momentum
        </div>
        <div
          className="text-[10px] font-mono uppercase tracking-widest"
          style={{ color: level.color }}
          data-testid="momentum-level"
        >
          {level.name}
        </div>
      </div>
      <div className="flex items-baseline justify-between mb-3">
        <div
          className="font-mono font-bold text-5xl tabular-nums transition-all"
          style={{ color: level.color, textShadow: `0 0 20px ${level.color}55` }}
          data-testid="momentum-score"
        >
          {score}
        </div>
        <div className="text-xs font-mono text-white/40">peak · {peak}</div>
      </div>
      <div className="h-1.5 rounded-full bg-white/5 overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{
            width: `${Math.min(100, score)}%`,
            background: `linear-gradient(90deg, ${level.color}88, ${level.color})`,
          }}
        />
      </div>
      <p className="mt-3 text-[11px] text-white/40 leading-relaxed">
        Ticks up every 3s of unbroken focus. Interrupt resets it.
      </p>
    </div>
  );
}
